"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueManagerComponent = void 0;
const core_1 = require("@angular/core");
const notification_service_1 = require("./notification.service");
const queue_manager_service_1 = require("./queue-manager.service");
const permission_service_1 = require("./permission.service");
let QueueManagerComponent = class QueueManagerComponent {
    constructor(_qService, _talk, _permission) {
        this._qService = _qService;
        this._talk = _talk;
        this._permission = _permission;
        this.stats = {};
        this.currentView = { name: null, content: [] };
        this.viewJobDetails = false;
        this.currentJob = null;
        this.searchTerm = "";
        //Time interval to request new stats;
        this.refreshIntervalTime = 5000;
        this.statsInterval = null;
    }
    ngOnInit() {
        this.permission = this._permission.get();
        this.viewStats();
        //Start new Stats requests
        this.statsInterval = setInterval(this.getStats.bind(this), this.refreshIntervalTime);
    }
    ngOnDestroy() {
        //Stop stats updates refresh
        this.clearStatsUpdateInterval();
    }
    viewStats() {
        this.getStats();
        this.currentView.name = 'stats';
    }
    getStats() {
        this._qService.getStats()
            .then(response => {
            if (response) {
                this.stats = response;
                //Update the current View Jobs content if stats count changed
                if (this.currentView.name && this.currentView.name !== 'stats') { //Only check update for non 'stats' views
                    let statsCount = this.stats[`${this.currentView.name}Count`];
                    if (statsCount !== this.currentView.content.length) {
                        this.getJobs(this.currentView.name, statsCount);
                    }
                }
            }
        })
            .catch(err => {
            console.error('Stats Request Error', err);
            this._talk.broadcast(`
                        <h1>Oops!:( There was a problem retrieving Stats content</h1>
                        <p>See error details on Browser console. </p>`);
            this.clearStatsUpdateInterval();
        });
    }
    getJobs(type, totalPages) {
        this._qService.getJobs(type, totalPages)
            .then(response => {
            if (response) {
                this.currentView.name = type;
                this.currentView.content = response;
            }
        })
            .catch(err => {
            console.error(`Error Requesting ${type} jobs`, err);
            this._talk.broadcast(`
                        <h1>Oops!:( There was a problem retrieving ${type} jobs content</h1>
                        <p>See error details on Browser console. </p>`);
        });
    }
    showJobDetails(job) {
        this.viewJobDetails = (!this.currentJob || job.id !== this.currentJob.id || job.id === this.currentJob.id && !this.viewJobDetails);
        if (this.viewJobDetails) {
            let jobData = {
                id: job.id,
                type: job.type,
                workerId: job.workerId,
                attempts: `${job.attempts.made} of ${job.attempts.remaining}`,
                durationTime: this.calculateDurationTime(job.started_at, job.updated_at),
                data: job.data
            };
            if (job.error) {
                let date = new Date();
                date.setTime(job.failed_at);
                jobData.errorTime = date;
                jobData.error = job.error.split(/\r?\n/)[0];
            }
            this.currentJob = jobData;
        }
    }
    deleteJob(jobId) {
        this._qService.deleteJob(jobId)
            .then(response => {
            if (response) {
                this.currentJob = null;
                //Find the deleted job in content
                let jobIdx = this.currentView.content.findIndex(job => job.id === jobId);
                this.currentView.content.splice(jobIdx, 1);
            }
        })
            .catch(err => {
            console.error(`Error deleting job(${jobId})`, err);
            this._talk.broadcast(`
                    <h1>Oops!:( Unable to delete job(${jobId})</h1>
                    <p>See error details on Browser console. </p>`);
        });
    }
    onSideMenuClick() {
        //Hide Job Details if open
        if (this.viewJobDetails) {
            this.viewJobDetails = !this.viewJobDetails;
        }
    }
    clearStatsUpdateInterval() {
        //Clear stats intervals, to avoid requiring failures requests
        if (this.statsInterval) {
            clearInterval(this.statsInterval);
        }
    }
    calculateDurationTime(startedTime, updatedTime) {
        let elapsedTime = new Date(parseInt(updatedTime) - parseInt(startedTime));
        return `${elapsedTime.getMinutes()}.${elapsedTime.getSeconds()}`;
    }
};
exports.QueueManagerComponent = QueueManagerComponent;
exports.QueueManagerComponent = QueueManagerComponent = __decorate([
    (0, core_1.Component)({
        selector: 'queue-manager',
        templateUrl: '../app/queue-manager.component.html',
        styleUrls: ['../styles/less/queue-manager.component.less']
    }),
    __metadata("design:paramtypes", [queue_manager_service_1.QueueManagerService,
        notification_service_1.NotificationService,
        permission_service_1.PermissionService])
], QueueManagerComponent);
//# sourceMappingURL=queue-manager.component.js.map